import api from "../../../api";
import { initLectureCategoryState } from "./category.inits";

/** @type {(import("vuex").Module<import("./category.inits").LectureCategoryState>)} */
export const category = {
    namespaced: true,

    state: initLectureCategoryState(),

    mutations: {
        setItems(state, { items }) {
            state.items = items;
        },
        setLoading(state, { loading }) {
            state.loading = loading;
        },
    },

    actions: {
        async getItems({ state, commit }, { isConsole = false } = {}) {
            if (state.loading) return;
            else commit("setLoading", { loading: true });

            try {
                let { gets } = api[isConsole ? "console" : "v1"].lectures.categories;
                let { categories } = await gets({
                    headers: { sort: JSON.stringify({ index: 1 }) },
                    params: { depth: 1 },
                });
                commit("setItems", { items: categories });
            } finally {
                commit("setLoading", { loading: false });
            }
        },
    },

    modules: {},
};
